// @flow

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

import injectTapEventPlugin from "react-tap-event-plugin";

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

// Root Component
import Root from "./Root";

// Initial setup and store
import { store } from "./setup/configureStore";

// App CSS
import "./index.css";
import "draft-js/dist/Draft.css";
import "@public/assets/fonts/567373/1B4E86DA7DBDFD2B8.css";
// Prefetch fonts for generating pdf (hits cache, since we load along with the CSS)
import { getFontsForPdf } from "./pdf/documentTemplate";
getFontsForPdf();

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept("./Root", () => {
    const NextApp = require("./Root").default;
    ReactDOM.render(
      <Provider store={store}>
        <NextApp />
      </Provider>,
      document.getElementById("root")
    );
  });
}



// WEBPACK FOOTER //
// ./src/index.js